import {
    RequestStatus,
    ServerRequestState,
} from 'dg-web-shared/lib/hooks/ServerStateHooks.ts';
import {
    isValidationData,
    useRequestErrorFieldMap,
} from 'dg-web-shared/common/utils/FormHooksUtils.tsx';
import {
    isFormGlobalViolationEntry,
    ValidationData,
} from 'dg-web-shared/lib/forms/FormValidationHelpers.tsx';
import Alert from '@mui/material/Alert';
import { Localized } from 'dg-web-shared/lib/Localization.tsx';
import { FieldValues, UseFormReturn } from 'react-hook-form';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';

export function useOperatorReqErrorFieldMap<TFieldValues extends FieldValues>(
    serverRequestState: ServerRequestState<unknown>,
    form: UseFormReturn<TFieldValues, unknown>,
) {
    const { language } = useLanguage();
    useRequestErrorFieldMap(serverRequestState, form, language);
}

export function OperatorFormSubmitError({
    submitState,
}: {
    submitState: ServerRequestState<unknown, ValidationData>;
}) {
    switch (submitState.status) {
        case RequestStatus.NEVER_EXECUTED:
        case RequestStatus.PENDING:
        case RequestStatus.SUCCESS:
            return null;
        case RequestStatus.ERROR: {
            const data = submitState.data;
            if (!data || !isValidationData(data)) {
                return (
                    <RequestErrorAlert
                        httpStatusCode={submitState.httpStatusCode}
                    />
                );
            }
            const violations = data.violations.filter(
                isFormGlobalViolationEntry,
            );

            if (violations.length === 0) {
                return (
                    <RequestErrorAlert
                        httpStatusCode={submitState.httpStatusCode}
                    />
                );
            }

            return (
                <>
                    {violations.map(e => (
                        <Alert
                            key={JSON.stringify(e.issue.message)}
                            severity="error"
                            sx={{ margin: '0 0 16px 0' }}
                        >
                            <Localized
                                {...e.issue.humanReadableMessage.byLanguage}
                            />
                        </Alert>
                    ))}
                </>
            );
        }
    }
}

function RequestErrorAlert({ httpStatusCode }: { httpStatusCode: number }) {
    return (
        <Alert severity="error" sx={{ margin: '0 0 16px 0' }}>
            <>
                <Localized
                    de="The request returned an error: status "
                    fr="The request returned an error: status "
                    it="The request returned an error: status "
                    en="The request returned an error: status "
                />
                {httpStatusCode}
            </>
        </Alert>
    );
}
